import React from 'react';

const FacebookSVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '20'}
    height={height ? height : '20'}
    viewBox="0 0 24 24"
  >
    <path
      fill={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M17.0097656,13.25 L17.5652344,9.63046875 L14.0921875,9.63046875 L14.0921875,7.28164063 C14.0921875,6.29140625 14.5773437,5.32617188 16.1328125,5.32617188 L17.7117187,5.32617188 L17.7117187,2.24453125 C17.7117187,2.24453125 16.2789062,2 14.9089844,2 C12.0488281,2 10.1792969,3.73359375 10.1792969,6.871875 L10.1792969,9.63046875 L7,9.63046875 L7,13.25 L10.1792969,13.25 L10.1792969,22 L14.0921875,22 L14.0921875,13.25 L17.0097656,13.25 Z"
    />
  </svg>
);

export default FacebookSVG;
